type ResizeCallback = (entry: ResizeObserverEntry) => void;

class ResizeObserverManager {
  private observer: ResizeObserver;
  private callbacks = new Map<Element, ResizeCallback>();

  constructor() {
    this.observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const cb = this.callbacks.get(entry.target);
        if (cb) cb(entry);
      }
    });
  }

  observe(element: Element, callback: ResizeCallback) {
    this.callbacks.set(element, callback);
    this.observer.observe(element);
  }

  unobserve(element: Element) {
    this.callbacks.delete(element);
    this.observer.unobserve(element);
  }
}

export const resizeObserverManager = new ResizeObserverManager();